"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Marketplace/components/Modal.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template);

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "position-absolute top-0 zindex-4 w-100 h-100 theme-bg-transparent",
      renderBody: function(out) {
        Bx_tag({
            type: "x",
            title: Locale("Dismiss"),
            class: "position-absolute right-0 font-large-1 p-2 cursor-pointer"
          }, out, __component, "1", [
          [
            "click",
            () => component.emit('dismiss'),
            false
          ]
        ]);

        marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "2");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
